<div>

  <div class="row" style="display: block; width: 100%; margin-bottom: 5px;">
    <label class="col-lg-3">Total Ports: {{table.totalRecords}}</label>
    <span class="col-lg-1"></span>
    <label class="col-lg-3">Selected Ports: {{selectedPortCount}}</label>
  </div>

  <p-table #table class="selector-ports-table" [value]="entries" compareSelectionBy="equals"
    [resizableColumns]="true" dataKey="dataKey"
    [scrollable]="true" [scrollHeight]="portTableHeight"
    [customSort]="true" (sortFunction)="doCustomSort($event)"
    [(selection)]="selectedPorts" (selectionChange)="onSelectionChange($event)"
    (onFilter)="onFilterChange()" [(first)]="first">

    <ng-template pTemplate="header">
      <tr>
        @if (selectionMode == 'single') {
          <th class="uv-table-checkbox"></th>
        }
        @if (selectionMode == 'multiple') {
          <th class="uv-table-checkbox">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
        }
        @for (col of cols; track col) {
          <th pResizableColumn [pSortableColumn]="col.field"
            class="bp-table-cell" [ngStyle]="{'flex-grow': col.width}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
      </tr>
      <tr>
        <th class="uv-table-checkbox"></th>
        @for (col of cols; track col) {
          <th class="bp-table-cell" [ngStyle]="{'flex-grow': col.width}">
            <input #filter pInputText type="text" style="width: 100%;"
              (input)="table.filter($event.target.value, col.field, col.filterMatchMode)">
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData">
          @if (selectionMode == 'single') {
            <td class="uv-table-checkbox">
              <p-tableRadioButton [value]="rowData"></p-tableRadioButton>
            </td>
          }
          @if (selectionMode == 'multiple') {
            <td class="uv-table-checkbox">
              <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
            </td>
          }
          @for (col of cols; track col) {
            <td class="bp-table-cell" [ngStyle]="{'flex-grow': col.width}">
              <span class="uv-table-value">{{rowData[col.field]}}</span>
            </td>
          }
        </tr>
      </ng-template>

    </p-table>

  </div>
